import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import { AddPendingPODs } from "../../Components/FormComponents";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import SearchBoxesDiv from "../../Components/HeaderDiv/HeaderDivComponents/SearchBoxesDiv/SearchBoxesDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "../CommonPage.scss";
import "./POD.scss";
const queryfunction = (fields) => {
  const query = gql`
  query getallPOD_Managements_With_StatusFilter($Status: String="Pending_For_Collection") {
    getallPOD_Managements_With_StatusFilter(Status: $Status) {
        _id
        ${fields?.join(" ")}
      }
    }
    `;

  return query;
};
const POD = () => {
  const [Tab, SetTab] = useState("Pending");
  const Key = "POD"
  const [FetchPODData, { loading: queryLoading, error, data }] = useLazyQuery(queryfunction([]), {
    variables: {
      Status: Tab === "Pending" ? "Pending_For_Collection" : Tab === "Collected" ? "Pending For Process" : Tab,
    },
  });
  const [_id, setId] = useState();
  const [formdata, setformdata] = useState(data ? data.getallPOD_Managements_With_StatusFilter : []);
  const [isLoading, setIsLoading] = useState(true);

  const [openUpdateModal, setOpenModal] = useState(false);

  const { loading, TableHeaders } = useFetchTableData(queryfunction, FetchPODData, setIsLoading, Key);

  useEffect(() => {
    let updatedData = data?.getallPOD_Managements_With_StatusFilter?.map((el) => {
      let obj = { ...el };
      delete obj.__typename;
      obj.Status = replaceUnderscore(obj.Status);
      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }
      if (Tab === "Pending") {
        obj.Update = (
          <a
            href="#"
            style={{ color: "blue", textDecoration: "none" }}
            onClick={() => {
              setOpenModal(true);
              setId(obj._id);
            }}
          >
            Update{" "}
          </a>
        );
      }
      return obj;
    });
    setformdata(updatedData);
    setIsLoading(false);
  }, [data]);


  let statusTab = [
    { name: "Pending" },
    { name: "Collected" },
    { name: "Intransit" },
    { name: "Received" },
    { name: "Submitted" },
  ];
  return (
    <div className="PodContainer">
      <div className="HeaderDiv">
        <div>
          <p className="pageTitle">POD</p>
          <div className="hr1ForPageTitle"></div>
        </div>
        <SearchBoxesDiv />
      </div>
      <Tabs tabs={statusTab} SetTabPage={SetTab} />
      <HeaderDiv title={""} MoreActions={{ Is_Process: true }} />
      {isLoading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          {(queryLoading || loading) && <div className="loader-line-div" />}
          <LoadTable data={formdata} loading={isLoading} error={error} title={`${Tab}_PODs`} Tab={Tab} TableHeaders={TableHeaders} />
          {openUpdateModal && (
            <AddPendingPODs
              id={_id}
              TypeOfPortal={"Update Pending POD"}
              show={openUpdateModal}
              ParentPortalCloseFunction={() => setOpenModal(false)}
            />
          )}
        </>
      )}
    </div>
  );
};

export default POD;
